import React from 'react';

import { YatModalSideSheet, type YatModalSideSheetProps } from '@pkg/components';

import './SidePanel.scss';

export interface YatSidePanelProps extends YatModalSideSheetProps {
    header?: React.ReactElement;
    modalLabelId: string;
}

const YatSidePanel = (sidePanelProps: YatSidePanelProps) => {
    return (
        <div className="yat-side-panel">
            <YatModalSideSheet {...sidePanelProps}>{sidePanelProps.children}</YatModalSideSheet>
        </div>
    );
};

export default YatSidePanel;
